module.exports = __webpack_public_path__ + "odinstatic/v5.0.2/media/placement.a1117be5.svg";